<!--
 * @Author: awu
 * @Date: 2020-11-16 23:14:32
 * @LastEditors: awu
 * @LastEditTime: 2020-12-09 22:44:51
 * @Description: 咨询台
-->
<template>
    <div class="consult">
        <iframe  :src="iframesrc"  style="width:100%;height:100%;border:0;" ></iframe> 
        <div class="warpper" v-show="isShow">
            <!-- <div class="play" @click="playVideo">
                <img src="../../assets/conference/play.png" alt="" />
            </div> -->
            <div class="btn" v-show="btnShowFlag" @click="toPath('/area/consult/relation')" style="left: 21.98%">{{ $t("consult").title }}</div>
            <div class="btn" v-show="btnShowFlag" @click="toPath('/area/consult/rcap')" style="right: 11.5%">{{ $t("agenda").title }}</div>
            <router-view></router-view>
        </div>
    </div>
</template>
<script>
import api from "@/api";
import Video from "../../components/video";
import { CONSULTANT_VIDEO_URL, EXHIBITION_ID } from "../../assets/common/data";

export default {
    components: {
        Video
    },
    data() {
        return {
            iframesrc: '',
            btnShowFlag: true,
            videoFlag: false,
            isShow: false,
            exhibition_id: '',
            mainVideoSrc: '',
        };
    },
    beforeMount() {},
    mounted() {
        this.exhibition_id = this.$route.query.exhibition_id
        // alert(this.exhibition_id)
        this.btnShowFlag = true;
        this.videoFlag = false;
        this.isShow = false;
        this.$root.$on("close", () => {
            this.btnShowFlag = true;
        });
        switch (Number(this.exhibition_id)) {
            case 21:
                this.iframesrc = "https://pano.cloudvhall.com/#/preview?view_uuid=0004071750fe2ac1";
                break;
            case 25:
                this.iframesrc = "https://pano.cloudvhall.com/#/preview?view_uuid=dd1d4920d18a6d4c";
                break;
            case 31:
                this.iframesrc = "https://pano.cloudvhall.com/#/preview?view_uuid=32732f833966742d";
                break; 
            case 50:
                this.iframesrc = "https://veh.cloudvhall.com/#/preview/ZWMwcWtkYjVUbnRZMXJoVVYrRUV1dz09";
                break;
            case 60:
                this.iframesrc = "https://veh.cloudvhall.com/#/preview/ZWp5cWIwRFJYSDh0dXhxaGFLODhTUT09";
                break;
            case 82:
                this.iframesrc = "https://veh.cloudvhall.com/#/preview/NW1lcjMybVc1RWhKdkZORjlLcHVDQT09";
                break;
            default:
                break;
        }

        // this.$refs.video.addEventListener("ended", () => {
        //     this.isShow = true;
        // });
    },
    watch: {
        $route: {
            handler(route) {
                console.log( route.query.exhibition_id)
                console.log( this.exhibition_id)
                let route_exhibition_id = route.query.exhibition_id
                if(route_exhibition_id){
                    switch (route.query.exhibition_id) {
                        case '21':
                            this.iframesrc = "https://pano.cloudvhall.com/#/preview?view_uuid=0004071750fe2ac1";
                            break;
                        case '25':
                            this.iframesrc = "https://pano.cloudvhall.com/#/preview?view_uuid=43f7e3bec3df96a8";
                            break;
                         case '31':
                            this.iframesrc = "https://pano.cloudvhall.com/#/preview?view_uuid=32732f833966742d";
                            break;
                        case '50':
                            this.iframesrc = "https://veh.cloudvhall.com/#/preview/ZWMwcWtkYjVUbnRZMXJoVVYrRUV1dz09";
                            break;
                        case '60':
                            this.iframesrc = "https://veh.cloudvhall.com/#/preview/ZWp5cWIwRFJYSDh0dXhxaGFLODhTUT09";
                            break;
                        default:
                            break;
                    }
                }
            },
		    immediate: true,
        },
    },
    methods: {
        toPath(item) {
            this.btnShowFlag = false;
            this.$router.push(item);
        },
        playVideo() {
            this.videoFlag = true;
            this.btnShowFlag = false;
        },
        close() {
            this.videoFlag = false;
            this.btnShowFlag = true;
        }
    }
};
</script>

<style lang="scss" scoped>
.consult {
    width: 100%;
    height: 100vh;
    background-size: 100% 100%;
    position: relative;
    #videoPlay {
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 5;
    }
    .warpper {
        width: 100%;
        height: 100%;
        // background: url("https://static.cloudvhall.com/DTSW/infomation.jpg");
        background-size: 100% 100%;
    }
    .play {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        background-color: #595b5f;
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: center;
        top: 38%;
        left: 53%;
        cursor: pointer;
    }
    .btn {
        position: absolute;
        width: 177px;
        height: 45px;
        line-height: 45px;
        background: #ffffff;
        border-radius: 23px;
        text-align: center;
        top: 50%;
        transform: translateY(-50%);
        font-size: 13px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #09468c;
        letter-spacing: 1px;
        cursor: pointer;
        z-index: 99999;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/consult/index.vue